<template>
  <div @mouseenter="onMouseEnter"
       @mouseleave="onMouseLeave" style="background: pink;">
    <div class="btn-toggle-visible" @click="onClickToggleVisibleBtn">
      <i class="el-icon-arrow-down is-down"></i>
    </div>
    <div class="toggle-visible-tooltip">{{ tip }}</div>
  </div>

</template>

<script>
import i18n from '../../language/index'

export default {
  name: "btnHideTopBar.vue",
  data() {
    return {}
  },
  computed: {
    topBarVisible() {
      return this.$store.state.app.topBarVisible
    },
    tip() {
      return this.topBarVisible ? i18n.t('view_public_btnhidetopbar_29') : i18n.t('view_public_btnhidetopbar_28')
    }
  },
  methods: {
    onClickToggleVisibleBtn() {
      if (this.topBarVisible) {
        $('.g_header_content__fixed').css({
          top: 0 + 'px'
        })
        $('#app_child_frame .topBar').css({
          top: '-72px',
          'box-shadow': 'none'
        })
        $('.top_bar_placeholder').css({
          height: 0
        })
        //el-icon-arrow-down.is-up
        $('.btn-toggle-visible .el-icon-arrow-down').addClass('is-up')
        this.$store.commit('app/setTopBarVisible', false)
      } else {
        $('#app_child_frame .topBar').css({
          top: '0',
          'box-shadow': '0 3px 5px 1px rgba(0, 0, 0, 0.1)'
        })
        $('.top_bar_placeholder').css({
          height: this.$store.state.app.topBarHeight + 'px'
        })
        $('.btn-toggle-visible .el-icon-arrow-down').removeClass('is-up')
        this.$store.commit('app/setTopBarVisible', true)
      }
      this.templet.fixed_header()
    },
    onMouseEnter() {
      $('.toggle-visible-tooltip').removeClass('tooltip-leave').addClass('tooltip-enter')
    },
    onMouseLeave() {
      $('.toggle-visible-tooltip').removeClass('tooltip-enter').addClass('tooltip-leave')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-toggle-visible {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 110px;
  //height: 16px;
  //line-height: 16px;
  line-height: 1;
  padding-top: 3px;
  padding-bottom: 2px;
  background: #F3F4F6;
  border-radius: 0 0 16px 16px;
  z-index: 2000;
  cursor: pointer;
  text-align: center;
  font-weight: bold;
  transition: all 0.3s;

  &:hover {
    background: #3D8AFF;

    .el-icon-arrow-down {
      color: #fff;
    }
  }

  .el-icon-arrow-down {
    font-size: 12px;
    vertical-align: top;
    transition: transform 0.3s;
  }

  .el-icon-arrow-down.is-up {
    transform: rotate(180deg);
  }
}

.toggle-visible-tooltip {
  box-sizing: border-box;
  padding: 11px 16px;
  font-size: 13px;
  line-height: 22px;
  color: #666;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 0 14px rgba(0, 0, 0, .15);
  text-align: justify;
  animation-name: zoomIn;
  animation-iteration-count: 1;
  animation-duration: .3s;
  animation-delay: 0s;
  animation-timing-function: cubic-bezier(.23, 1, .32, 1);
  animation-fill-mode: both;
  backface-visibility: hidden;
  z-index: 9999;

  position: fixed;
  top: 20px;
  left: 0;
  right: 0;
  margin: auto;
  width: 130px;
  display: none;
  visibility: hidden;
}

.tooltip-enter {
  display: block;
  visibility: visible;
}

.tooltip-leave {
  display: none;
  visibility: hidden;

  animation-name: zoomOut;
  animation-iteration-count: 1;
  animation-duration: .3s;
  animation-delay: 0s;
  animation-timing-function: cubic-bezier(.23, 1, .32, 1);
  animation-fill-mode: both;
}

@keyframes zoomIn {
  0% {
    opacity: 0;
    transform: scale3d(.3, .3, .3)
  }

  50% {
    opacity: 1
  }
}

@keyframes zoomOut {
  0% {
    opacity: 1
  }

  50% {
    opacity: 0;
    transform: scale3d(.3, .3, .3)
  }
}
</style>



// WEBPACK FOOTER //
// src/view/public/btnHideTopBar.vue